export function leadBasedPaintObligationsSeller2027() {
return [   // Release 2026-10-01 19:57:05
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 228.425,
   left: 199.309,
   width: 360.677,
   height: 14.695
}
] }
